import { createContext, useContext, useMemo } from 'react';

import { IFieldStyles, IFormStyles } from 'schema/generator/FormSchema';

export const StyleCtx = createContext({} as IFormStyles);

export const useStyles = <T extends IFieldStyles>(
  type: keyof IFormStyles,
  inlineStyles?: T,
): T => {
  const baseStyles = useContext(StyleCtx);

  return useMemo(() => {
    return inlineStyles
      ? { ...baseStyles[type], ...inlineStyles }
      : (baseStyles[type] as T);
  }, [type, baseStyles, inlineStyles]);
};
